import classNames from 'classnames'
import React from 'react'

import { ReactComponent as ErrorIcon } from '~/assets/icons/error.svg'

interface IProperties {
  message: string
  className?: string
}

const InputErrorMessage: React.FC<IProperties> = ({ message, className }) => {
  return (
    <div
      className={classNames(
        'p-1 w-full flex gap-1 items-center rounded-sm bg-red-200 mt-0.5',
        className
      )}
    >
      <ErrorIcon className="w-4 h-4 flex-none text-red-700" />
      <p className="text-xs text-neutral-black font-bold">{message}</p>
    </div>
  )
}

export default InputErrorMessage
